import ErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import InstallApp from 'Components/InstallApp';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { stores } from 'stores';
import { observer } from 'mobx-react';
import Menu from './Components/Menu';
import * as S from './styled';
import { MaintenaceModalDefault } from '../../Modals/Maintenace/default';

const { ProfileStore } = stores;

function AppLayoutDefaultRaw({
  children,
  contentBackground,
  contentContainerRef,
  sidebarRef,
  containerRef,
}) {
  return (
    <S.Layout ref={containerRef}>
      {ProfileStore.needToShowMaintenanceWarning && <MaintenaceModalDefault />}
      <Menu sidebarRef={sidebarRef} />
      <S.Content
        ref={contentContainerRef}
        id="AppLayoutContent"
        background={contentBackground}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </S.Content>
      <InstallApp />
    </S.Layout>
  );
}

export const AppLayoutDefault = withRouter(observer(AppLayoutDefaultRaw));
